import { Component, OnInit, Input } from '@angular/core';
import { ILocation } from 'src/app/services/location.service';
//import { Geolocation } from '@awesome-cordova-plugins/geolocation/ngx';
//import { Geoposition } from '@awesome-cordova-plugins/geolocation';
//import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';
import { Browser } from '@capacitor/browser';
import { PhonePipe } from 'src/app/shared/pipes/phone.pipe';
import { SettingService } from 'src/app/shared/services/setting.service';


interface Geoposition {
  coords: {
    latitude: number;
    longitude: number;
    accuracy?: number;
    altitude?: number | null;
    altitudeAccuracy?: number | null;
    heading?: number | null;
    speed?: number | null;
  };
  timestamp: number;
}

@Component({
    selector: 'location-banner',
    templateUrl: './location-banner.component.html',
    styleUrls: ['./location-banner.component.scss'],
    standalone: false
})
export class LocationBannerComponent implements OnInit {
  private _location: ILocation;
  private _position: Geoposition;
  directionUrl: string;
  telephoneNumber: string;
  @Input('location')
  set location(location: ILocation) {
    this._location = location;
    if (this.position && location)
      this.directionUrl = `https://www.google.com/maps/dir/?api=1&origin=${this.position.coords.latitude},${this.position.coords.longitude}&destination=${this.location.Latitude},${this.location.Longitude}`;
  }

  get location(): ILocation {
    return this._location;
  }

  @Input('position')
  set poisition(position: Geoposition) {
    this._position = position;
    if (position && this.location)
      this.directionUrl = `https://www.google.com/maps/dir/?api=1&origin=${this.position.coords.latitude},${this.position.coords.longitude}&destination=${this.location.Latitude},${this.location.Longitude}`;
  }

  get position() {
    return this._position;
  }

  homersLayout: boolean = false;
  tempImg = "assets/imgs/location/default.png"

  constructor(//private inAppBrowser: InAppBrowser,
    private phonePipe: PhonePipe,
    public setting: SettingService) { }

  ngOnInit() {
    if(this.setting.configuration.uIoptions && this.setting.configuration.homePageConfiguration != null && this.setting.configuration.uIoptions?.homePageOption == 10) {
      this.homersLayout = true;
    } else {
      this.homersLayout = false;
    }
  }

  getImage() : string {
    if (this.location.ImageUrl)
        return this.location.ImageUrl;

    return "assets/imgs/location/default.png";
  }
  getNumber(location)
  {
    return `<a href="tel:${location.Phone}" >${this.phonePipe.transform(location.Phone)}</a>`
  }
  async onDirectionClicked() {
    /*
      const browser = this.inAppBrowser.create(this.directionUrl, '_system', {
        location: 'no',
      });
      */
     await Browser.open({
      url: this.directionUrl,
      windowName: '_system' // optional, can also leave it out
    });
  }
}
